import { h } from 'preact';
import ProductTile from './ProductTile';
import './ProductList.scss';

export default function ProductList(props) {
  return (
    <div className="_ic__productList">
      {props.products.map(product => <ProductTile product={product} />)}
    </div>
  );
}
